import React from 'react'
import Logo from '../../../../assets/img/ares-logo-toogle.png'
import { Marker } from 'react-google-maps'

const Markers = ({ callback, data }) => {

  return data.map((history, index) => (
    <Marker
      key={index}
      position={{ lat: history.location[0], lng: history.location[1] }}
      icon={{
        url: Logo,
        scaledSize: new window.google.maps.Size(20, 30)
      }}
      // callback={(MarkerDeviceCallback)}
      onClick={() => callback(history)}
    />
  ))
}

export default Markers
